import React, { useContext, useState, useEffect, useMemo } from "react";
import Button from 'react-bootstrap/Button';
import { Form } from 'react-bootstrap';
import { createJD, createJdInsert, safetyCheck } from "Api/apiService";
import { AuthContext } from "State/AuthContext";
import "Components/SbJdCreationDrawer/SbJdCreationDrawer.scss"
import { useDispatch } from 'react-redux';
import { showNotification } from 'Store/actions/notificationActions';
//import { Country, State, City } from 'country-state-city';
import Permission from "Components/Permission";
import analytics,{ANALYTICS_EVENTS} from "Utils/analytics";
import { sanitizeHtml } from "Utils/sanitizeHtml";

const SbJdCreationDrawer = ({ email, accessToken, isDrawerOpen, toggleDrawer, setReloadRoles, setWaitingforResponse, setLlmresponse, setUploadJdResponseId, setCreateJdResponseId }) => {

    const dispatch = useDispatch();  // Get dispatch function
    const { orgMetaData } = useContext(AuthContext);

    const [jdActionSelection, setJdActionSelection] = useState('create');// for selection of upload/create

    const [safetyScanning, setsafetyScanning] = useState(false);
    // const [loadingLocations, setloadingLocations] = useState(false);
    const [safetyCheckPassedFile, setSafetyCheckPassedFile] = useState(null);
    const [safetyCheckPassedRContext, setSafetyCheckPassedRContext] = useState(null);
    const [safetyCheckPassedBContext, setSafetyCheckPassedBContext] = useState(null);

    // State variables for form data
    const [roleTitle, setRoleTitle] = useState('');
    const [altRoleTitle, setAltRoleTitle] = useState('');
    const [functionDepartment, setFunctionDepartment] = useState('');
    const [reportingTo, setReportingTo] = useState('');
    const [location, setLocation] = useState('');
    const [jobGrade, setJobGrade] = useState('');
    const [roleType, setRoleType] = useState('');
    const [technicalCompetence, setTechnicalCompetence] = useState('');
    const [roleContext, setRoleContext] = useState('');
    const [businessContext, setBusinessContext] = useState('');
    const [file, setFile] = useState(null);

    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [orgMetaDataCompany, setorgMetaDataCompany] = useState(orgMetaData?.company_structure);
    const [orgName, setOrgName] = useState("");
    const [orgIndustry, setOrgIndustry] = useState("");
    const [searchInput, setSearchInput] = useState('');
    // const [statesAndCities, setStatesAndCities] = useState([]);
    const [selectedlocation, setSelectedlocation] = useState(true);
    // const [countryOptions, setCountryOptions] = useState([]);

    const { statesAndCities, setStatesAndCities, countryOptions, setCountryOptions, loadingLocations } = useContext(AuthContext);

    // Add selectedLocations state for multi-location support
    const [selectedLocations, setSelectedLocations] = useState([]);

    // --- New state for keyboard navigation and highlight ---
    const [highlightedIndex, setHighlightedIndex] = useState(-1);
    // --- End new state ---

    // Update location whenever selectedLocations changes
    useEffect(() => {
        setLocation(selectedLocations.map(loc => loc.name).join(', '));
    }, [selectedLocations]);

    // function to manage the upload create radio change
    const handleRadioChange = (event) => {
        setJdActionSelection(event.target.value);
    };

    // resetting the state variables
    setReloadRoles(false);
    setWaitingforResponse(false);
    setLlmresponse();
    setUploadJdResponseId('');
    setCreateJdResponseId('');

    // Add useEffect to reset dropdown state when drawer opens
    useEffect(() => {
        if (isDrawerOpen) {
            setSelectedlocation(true); // Close dropdown
            setSearchInput(''); // Clear input
        }
    }, [isDrawerOpen]);

    // Debounce search input
    useEffect(() => {
        const timer = setTimeout(() => {
            setSearchInput(searchInput);
        }, 500);

        return () => clearTimeout(timer);
    }, [searchInput]);


    // Memoized filtered options based on search input
    const memoizedFilteredOptions = useMemo(() => {
        const query = searchInput.toLowerCase();
        return statesAndCities.filter((option) =>
            option.name.toLowerCase().includes(query)
        ).slice(0, 5000); // Limit to the first 50 results
    }, [searchInput, statesAndCities]); // Added statesAndCities for safety

    // useEffect(() => {
    //     setloadingLocations(true);
    //     const fetchData = async () => {
    //         try {
    //             // Fetch all countries
    //             const countries = await Country.getAllCountries();
    //             setCountryOptions(countries);
    //             const cityCountryArray = [];  // Array to store city-country combinations

    //             for (let i = 0; i < countries.length; i++) {
    //                 const country = countries[i];
    //                 const states = await State.getStatesOfCountry(country.isoCode);

    //                 for (const state of states) {
    //                     const cities = await City.getCitiesOfState(country.isoCode, state.isoCode);

    //                     cities.forEach((city) => {
    //                         // Combine city and country in the required format
    //                         const cityStateCountryCombination = `${city.name} - ${state.name}, ${country.name}`;

    //                         // Add this combination to the array
    //                         cityCountryArray.push({
    //                             name: cityStateCountryCombination,
    //                             type: 'city - state - country',
    //                             country: country.name,
    //                             state: state.name,
    //                             city: city.name,
    //                         });
    //                     });
    //                 }

    //                 await new Promise(resolve => setTimeout(resolve, 0)); // Break to update UI
    //             }

    //             setStatesAndCities(cityCountryArray);
    //         } catch (error) {
    //             console.error("Error fetching data:", error);
    //         } finally {
    //             setloadingLocations(false);
    //         }
    //     };
    //     fetchData();
    // }, []);


    const handleInputChange = (e) => {
        setSearchInput(e.target.value);
        setSelectedlocation(false); // Open dropdown on input
        setHighlightedIndex(-1); // Reset highlight on input change
    };

    // --- Keyboard navigation handler for location input ---
    const handleLocationKeyDown = (e) => {
        if (!memoizedFilteredOptions.length) return;
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            setHighlightedIndex((prev) =>
                prev < memoizedFilteredOptions.length - 1 ? prev + 1 : 0
            );
            setSelectedlocation(false);
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            setHighlightedIndex((prev) =>
                prev > 0 ? prev - 1 : memoizedFilteredOptions.length - 1
            );
            setSelectedlocation(false);
        } else if (e.key === 'Enter') {
            if (highlightedIndex >= 0 && highlightedIndex < memoizedFilteredOptions.length) {
                e.preventDefault();
                handleSelectOption(memoizedFilteredOptions[highlightedIndex]);
                setHighlightedIndex(-1);
            }
        } else if (e.key === 'Escape') {
            setSelectedlocation(true); // Close dropdown
            setHighlightedIndex(-1);
        }
    };
    // --- End keyboard navigation handler ---

    // Update handleSelectOption to clear input and keep dropdown ready
    const handleSelectOption = (option) => {
        if (!selectedLocations.some(loc => loc.name === option.name)) {
            setSelectedLocations(prev => [...prev, option]);
        }
        setSearchInput('');
        setSelectedlocation(true); // Close dropdown after selection
        setHighlightedIndex(-1); // Reset highlight
    };

    // Update handleRemoveLocation to close dropdown after removal
    const handleRemoveLocation = (indexToRemove) => {
        setSelectedLocations(prev =>
            prev.filter((_, index) => index !== indexToRemove)
        );
        setSelectedlocation(true); // Close dropdown after removal
        setHighlightedIndex(-1); // Reset highlight
    };

    useEffect(() => {
        if (orgMetaDataCompany) {

            if (orgMetaData.org_name) {
                setOrgName(orgMetaData.org_name);
            }

            if (orgMetaData.org_industry) {
                setOrgIndustry(orgMetaData.org_industry[0]);
            }

            if (orgMetaData?.business_context?.industry) {
                setBusinessContext(orgMetaData.business_context.industry);
            }
        }

    }, [orgMetaDataCompany]);

    // Validate form fields
    const validateForm = () => {
        // Check for missing required fields and return an object with name, id, and type
        if (!roleTitle) return { name: 'Company Specific Job / Role Title', id: 'roleTitle', type: 'field' };
        if (!altRoleTitle) return { name: 'Generic or Industry Job / Role Title', id: 'altRoleTitle', type: 'field' };
        if (!functionDepartment) return { name: 'Function/Department', id: 'functionDepartment', type: 'dropdown' };
        if (!location) return { name: 'Location', id: 'location', type: 'dropdown' };
        if (!roleType) return { name: 'Role Type', id: 'roleType', type: 'dropdown' }; // Example of dropdown
        if (!reportingTo) return { name: 'Reporting To', id: 'reportingTo', type: 'dropdown' };
        if (!technicalCompetence) return { name: 'Technical Competence', id: 'technicalCompetence', type: 'dropdown' };
        if (!jobGrade) return { name: 'Job Grade', id: 'jobGrade', type: 'dropdown' }; // Example of dropdown

        return null; // All fields are filled
    };

    // Handle form submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        // Validate form
        const missingField = validateForm();
        if (missingField) {
            const { name, id, type } = missingField;

            // Customize error message based on field type (field or dropdown)
            if (type === 'field') {
                setError(`Enter ${name}.`);
            } else if (type === 'dropdown') {
                setError(`Select ${name}.`);
            }

            // Focus the first missing field using its ID
            document.getElementById(id).focus();
            return;
        }

        // If file is not uploaded returns false, stop further validation
        if (jdActionSelection == "revise" && file === null) {
            setError('Upload an existing JD.');
            return; // Stop and return false
        }


        // Call dataSafetyCheck based on the presence of roleContext
        let dataCheckResultRole;

        if (roleContext !== "") {
            dataCheckResultRole = await dataSafetyCheck(null, roleContext, "");
        }

        let error_message = "";
        const googleSafetyLink = '<a class="google-safety-link inherit-color" href="https://safety.google/content-safety/" target="_blank" rel="noopener noreferrer">Google Safety Check</a>';

        if (dataCheckResultRole === false) {
            error_message = `Role Context did not pass ${googleSafetyLink}. Revise and Submit.`;
        }

        setError(error_message);


        // If dataSafetyCheck returns false, stop further validation
        if (dataCheckResultRole === false) {
            return; // Stop and return false
        }

        // If dataSafetyCheck returns false, stop further validation
        if (jdActionSelection == "revise" && safetyCheckPassedFile == false) {
            setError('Uploaded file did not pass the Google safety check. Revise and Submit.');
            return; // Stop and return false
        }


        // Create payload for JD creation
        const formData = new FormData();
        formData.append('role', roleTitle);
        formData.append('alt_role_title ', altRoleTitle);
        formData.append('email', email);
        formData.append('company', orgName);
        formData.append('industry', orgIndustry);
        formData.append('reportingTo', reportingTo);
        formData.append('location', location);
        formData.append('function', functionDepartment);
        formData.append('level', jobGrade);
        formData.append('role_type', roleType);
        formData.append('technical_competence', technicalCompetence);
        formData.append('business_context', businessContext);

        if (!safetyCheckPassedRContext) {
            formData.append('role_context', roleContext);
        }


        setLoading(true);
        setWaitingforResponse(true);

        try {
            const jdResponse = await createJdInsert(formData, accessToken);

            if (jdResponse && jdResponse.job_id) {
                setLoading(false);
                setWaitingforResponse(true);
                toggleDrawer();
                setReloadRoles(true);
                setCreateJdResponseId(jdResponse.job_id);
                setUploadJdResponseId("");
                await createJdNextCall(jdResponse.job_id);
            } else {
                setLoading(false);
                setError('Could not create JD. Please retry.');
                dispatch(showNotification('Could not create JD. Please retry.', 'error'));
                setWaitingforResponse(false);
                setLlmresponse(false);
                toggleDrawer();
                setReloadRoles(false);
            }
        } catch (error) {
            console.error('Failed to create JD:', error);
            setLoading(false);
            setError('Failed to create JD.');
            dispatch(showNotification('Could not create JD. Please retry.', 'error'));
            setWaitingforResponse(false);
            setLlmresponse(false);
            toggleDrawer();
            setReloadRoles(false);
        }

    };

    // Function to check data safety
    const dataSafetyCheck = async (selectedFile = null, enteredRoleContext = "", enteredBusinessContext = "") => {

        setError(""); // Reset error before each fetch

        if (selectedFile !== null) {
            setsafetyScanning(true);
        }
        if (enteredRoleContext === "" && enteredBusinessContext === "" && selectedFile === null) {
            return false;
        }

        if ((enteredRoleContext !== "" || enteredBusinessContext !== "") && selectedFile === null) {
            setLoading(true);
        }

        let passedValue = "";

        const formData = new FormData();
        formData.append('email', email);

        if (enteredRoleContext !== "") {
            formData.append('role_context', enteredRoleContext);
            passedValue = "role_context";
            setSafetyCheckPassedRContext(false);
        }


        if (enteredBusinessContext !== "") {
            formData.append('business_context', enteredBusinessContext);
            passedValue = "business_context";
            setSafetyCheckPassedBContext(false);
        }

        if (selectedFile !== null) {
            formData.append('file', selectedFile);
            passedValue = "file";
            setSafetyCheckPassedFile(false)
        }

        try {
            const safetyCheckResponse = await safetyCheck(formData, accessToken);
            if (safetyCheckResponse && safetyCheckResponse.is_safe === true) {
                setsafetyScanning(false);
                setLoading(false);
                if (passedValue == "file") {
                    setSafetyCheckPassedFile(true);
                }
                if (passedValue == "role_context") {
                    setSafetyCheckPassedRContext(true);
                }
                if (passedValue == "business_context") {
                    setSafetyCheckPassedBContext(true);
                }
                return true;
            } else {
                setsafetyScanning(false);
                setLoading(false);
                if (passedValue == "file") {
                    setSafetyCheckPassedFile(false);
                }

                if (passedValue == "role_context") {
                    setSafetyCheckPassedRContext(false);
                }

                if (passedValue == "business_context") {
                    setSafetyCheckPassedBContext(false);
                }
                return false;
            }
        } catch (error) {
            console.error('Error validating safety check:', error);
            setsafetyScanning(false);
            setLoading(false);
            if (passedValue == "file") {
                setSafetyCheckPassedFile(false);
            }
            if (passedValue == "role_context") {
                setSafetyCheckPassedRContext(false);
            }
            if (passedValue == "business_context") {
                setSafetyCheckPassedBContext(false);
            }
            setError('Could not run safety checks. Please retry.');
            return false;
        }
    };

    // Function to call create jd
    const createJdNextCall = async (job_id) => {
        setLoading(true);
        setError(null); // Reset error before each fetch

        const payload = {
            "email": email,
            "job_id": job_id
        };

        try {
            const createResponse = await createJD(JSON.stringify(payload), accessToken);
            if (createResponse) {
                setLoading(false);
                dispatch(showNotification('JD created successfully', 'success'));
                setWaitingforResponse(false);
                setLlmresponse(true);
            } else {
                setLoading(false);
                setError('Could not create JD. Please retry.');
                dispatch(showNotification('Could not create JD. Please retry.', 'error'));
                setWaitingforResponse(false);
                setLlmresponse(false);
            }
        } catch (error) {
            console.error('Error creating file:', error);
            setLoading(false);
            setError('Could not create JD. Please retry.');
            dispatch(showNotification('Could not create JD. Please retry.', 'error'));
            setWaitingforResponse(false);
            setLlmresponse(false);
        }
    };

    const handleCloseDrawer = () =>{
        analytics.trackCloseDrawer({
            from : 'job details',
            email,
            description: ANALYTICS_EVENTS.JOBS_LIBRARY.JOB_DETAILS.REVISE_JD_DRAWER_CLOSE
        });
        toggleDrawer();
    }

    return (
        <div>

            {/* Overlay that darkens the background */}
            {isDrawerOpen && <div className="overlay" onClick={handleCloseDrawer}></div>}

            {/* Drawer that slides in from the right */}
            <div className={`drawer ${isDrawerOpen ? 'open' : ''}`}>
                <div className="drawer-header">
                    <div className="radio-buttons custom-tabs">


                        <div
                            className={`tab-title ${jdActionSelection === 'revise' ? 'active' : ''} 'disabled'`}
                            onClick={null}
                            style={{ cursor: 'not-allowed' }}
                        >
                            Revise JD
                        </div>
                        <div
                            className={`tab-title ${jdActionSelection === 'create' ? 'active' : ''}`}
                            onClick={() => handleRadioChange({ target: { value: 'create' } })}
                        >
                            Create JD
                        </div>
                    </div>

                    <div onClick={toggleDrawer} title="Close">
                        <svg width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 6.85693L6 20.5712" stroke="#2F3437" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 6.85693L18 20.5712" stroke="#2F3437" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>

                    </div>
                </div>

                <div className="drawer-body">

                    <Form onSubmit={handleSubmit} autoComplete="off">
                        <div>
                            <div className="upload-role-section d-flex w-100 mb-4">
                                <div className="role-title-sec w-100 d-flex flex-column">
                                    <Form.Group controlId="roleTitle" className="mb-4 w-100 me-3">
                                        <Form.Label>Company Specific Job / Role Title *</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={roleTitle}
                                            onChange={(e) => setRoleTitle(e.target.value)}
                                            placeholder="Enter Company Specific Job / Role Title"
                                        />
                                    </Form.Group>

                                    <Form.Group controlId="altRoleTitle" className="w-100">
                                        <Form.Label>Generic or Industry Job / Role Title *</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={altRoleTitle}
                                            onChange={(e) => setAltRoleTitle(e.target.value)}
                                            placeholder="Enter Generic or Industry Job / Role Title"
                                        />
                                    </Form.Group>
                                </div>
                            </div>

                            <div className="d-flex w-100">

                                {/* Function/Department */}
                                <Form.Group controlId="functionDepartment" className="mb-4 w-100 me-3">
                                    <Form.Label>Function / Department*</Form.Label>
                                    <Form.Select
                                        value={functionDepartment}
                                        className="custom-select-drawer" // Apply custom select class
                                        onChange={(e) => setFunctionDepartment(e.target.value)}
                                    >
                                        <option value="">Select Function / Department</option>
                                        {/* Check if orgMetaData is valid and contains Functional_unit */}
                                        {Array.isArray(orgMetaDataCompany) &&
                                            orgMetaDataCompany.find(item => item.Functional_unit)?.Functional_unit?.map((unit, index) => (
                                                <option key={index} value={unit}>{unit}</option>
                                            ))
                                        }
                                    </Form.Select>
                                </Form.Group>

                                {/* Reporting To */}
                                <Form.Group controlId="reportingTo" className="mb-4 w-100">
                                    <Form.Label>Reporting To*</Form.Label>
                                    <Form.Select
                                        value={reportingTo}
                                        className="custom-select-drawer" // Apply custom select class
                                        onChange={(e) => setReportingTo(e.target.value)}
                                    >
                                        <option value="">Select Reporting To</option>
                                        {/* Check if orgMetaData is valid and contains report_to */}
                                        orgMetaDataCompany    {Array.isArray(orgMetaDataCompany) &&
                                            orgMetaDataCompany.find(item => item.report_to)?.report_to?.map((role, index) => (
                                                <option key={index} value={role}>{role}</option>
                                            ))
                                        }
                                    </Form.Select>
                                </Form.Group>

                            </div>

                            <div className="d-flex w-100">
                                {/* Job Grade */}
                                <Form.Group controlId="jobGrade" className="mb-4 w-100 me-3">
                                    <Form.Label>Job Grade*</Form.Label>
                                    <Form.Select
                                        value={jobGrade}
                                        className="custom-select-drawer" // Apply custom select class
                                        onChange={(e) => setJobGrade(e.target.value)}
                                    >
                                        <option value="">Select Job Grade</option>
                                        {Array.isArray(orgMetaDataCompany) &&
                                            orgMetaDataCompany.find(item => item.job_grade)?.job_grade &&
                                            (Array.isArray(orgMetaDataCompany.find(item => item.job_grade)?.job_grade) && // Check if it's an array of objects
                                                orgMetaDataCompany.find(item => item.job_grade)?.job_grade[0]?.level &&
                                                orgMetaDataCompany.find(item => item.job_grade)?.job_grade[0]?.description
                                                ?
                                                orgMetaDataCompany.find(item => item.job_grade)?.job_grade.map((item, index) => (
                                                    <option key={index} value={item.grade_title}>
                                                        {item.level} - {item.grade_title}
                                                    </option>
                                                ))
                                                :
                                                orgMetaDataCompany.find(item => item.job_grade)?.job_grade.map((value, index) => {
                                                    return (
                                                        <option key={index} value={value}>
                                                            {value}
                                                        </option>
                                                    );
                                                })
                                            )
                                        }
                                    </Form.Select>
                                </Form.Group>

                                {/* Location */}
                                <Form.Group controlId="location" className="mb-4 w-100">
                                    <Form.Label>City - State, Country*</Form.Label>
                                    {/* Display selected items as tags */}
                                    <div className="d-flex flex-wrap gap-2">
                                        {selectedLocations.map((location, index) => (
                                            <span key={index} className="badge bg-primary d-flex align-items-center">
                                                {location.name}
                                                <button
                                                    type="button"
                                                    className="btn-close btn-close-white ms-2"
                                                    aria-label="Remove"
                                                    onClick={() => handleRemoveLocation(index)}
                                                />
                                            </span>
                                        ))}
                                    </div>
                                    {loadingLocations ? (
                                        <div className="d-flex justify-content-center mb-3">
                                            <div className="spinner-border" role="status">
                                                <span className="sr-only"></span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            <div className="position-relative">
                                                <input
                                                    type="text"
                                                    autoComplete="off"
                                                    id="location"
                                                    className="form-control"
                                                    placeholder="Search City, State or Country"
                                                    value={searchInput}
                                                    onChange={handleInputChange}
                                                    onFocus={() => setSelectedlocation(false)}
                                                    onBlur={() => setTimeout(() => setSelectedlocation(true), 150)}
                                                    onKeyDown={handleLocationKeyDown} // <-- Keyboard navigation
                                                />
                                                {memoizedFilteredOptions.length > 0 && selectedlocation === false && (
                                                    <ul
                                                        className="list-group position-absolute w-100"
                                                        style={{ zIndex: 10, maxHeight: '200px', overflowY: 'auto' }}
                                                    >
                                                        {memoizedFilteredOptions.map((option, index) => (
                                                            <li
                                                                key={index}
                                                                className={`list-group-item${highlightedIndex === index ? ' active' : ''}`}
                                                                onMouseDown={() => handleSelectOption(option)}
                                                                onMouseEnter={() => setHighlightedIndex(index)}
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                {option.name}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </Form.Group>

                            </div>

                            <div className="d-flex w-100">
                                {/* Role Type */}

                                <Form.Group controlId="roleType" className="mb-4 w-100 me-3">
                                    <Form.Label>Role Type*</Form.Label>
                                    <Form.Select
                                        value={roleType}
                                        className="custom-select-drawer" // Apply custom select class
                                        onChange={(e) => setRoleType(e.target.value)}
                                    >
                                        <option value="">Select Role Type</option>
                                        {Array.isArray(orgMetaDataCompany) &&
                                            orgMetaDataCompany.find(item => item.role_type)?.role_type?.map((role, index) => (
                                                <option key={index} value={role}>{role}</option>
                                            ))
                                        }
                                    </Form.Select>
                                </Form.Group>

                                {/* Technical Competence */}
                                <Form.Group controlId="technicalCompetence" className="mb-4 w-100  me-3">
                                    <Form.Label>Technical Competence*</Form.Label>
                                    <Form.Select
                                        value={technicalCompetence}
                                        className="custom-select-drawer" // Apply custom select class
                                        onChange={(e) => setTechnicalCompetence(e.target.value)}
                                    >
                                        <option value="">Select Technical Competence</option>
                                        {/* Check if orgMetaData is valid and contains competency_by_role */}
                                        {Array.isArray(orgMetaDataCompany) &&
                                            orgMetaDataCompany.find(item => item.competency_by_role)?.competency_by_role &&
                                            Object.keys(orgMetaDataCompany.find(item => item.competency_by_role)?.competency_by_role).map((key, index) => (
                                                <option key={index} value={key}>{key}</option>
                                            ))
                                        }
                                    </Form.Select>
                                </Form.Group>

                            </div>
                            <Permission resource="jobs_library" actions={["prompt"]}>
                                <Form.Group controlId="roleContext" className="mb-4 w-100">
                                    <Form.Label>Role Context</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={roleContext}
                                        onChange={(e) => setRoleContext(e.target.value)}
                                        placeholder="Enter Role Context"
                                    />
                                </Form.Group>
                            </Permission>


                        </div>

                        {error && <div className="error-message-box">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M7.99989 0.00488281C3.58265 0.00488281 0.00488281 3.58265 0.00488281 7.99989C0.00488281 12.4171 3.58265 15.9949 7.99989 15.9949C12.4171 15.9949 15.9949 12.4171 15.9949 7.99989C15.9949 3.58265 12.4171 0.00488281 7.99989 0.00488281ZM7.00051 12.9968V10.998H8.99926V12.9968H7.00051ZM7.00051 3.00301V9.99864H8.99926V3.00301H7.00051Z" fill="#D14343" />
                            </svg>
                            <div className="error-message-holder">
                                <p className="error-message">Error</p>
                                <p className="error-message-text" dangerouslySetInnerHTML={{ __html: sanitizeHtml(error, { allowNewTabLinks: true }) }} />
                            </div>
                        </div>}

                        <div className="d-flex w-100 justify-content-end p-2">
                            {loading ? (
                                <div className="d-flex justify-content-center mb-3">
                                    <div className="spinner-border" role="status">
                                        <span className="sr-only"></span>
                                    </div>
                                </div>
                            ) : (
                                <Button className="btn-small" variant="primary" type="submit" disabled={(jdActionSelection === "revise" && safetyCheckPassedFile === false) || loading}>
                                    Submit
                                </Button>
                            )}
                        </div>

                    </Form>
                </div>
            </div >
        </div >
    );
}


export default SbJdCreationDrawer;